<template>
  <div class="container-fluid" id="genericerror-step">
    <h2 class="text-center mt-2">{{ t("WERESORRYERROR") }}</h2>
    <img
      alt="error"
      :src="`${useAsset('img/credit-line/sorryno.png')}`"
      class="mx-auto d-block"
    />
    <div id="other-offer-card" class="mt-4 mb-5">
      <p v-if="errorCode">{{ t(`CL_ERROR_CODES.${errorCode}`) }}</p>
      <p v-else>{{ t("SORRYERRORDESC") }}</p>
      <hr />
      <a href="javascript:;" @click="$router.go(0)" class="reject-link">
        {{ t("TRYAGAIN") }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";

export default defineComponent({
  name: "RegistrationGenericError",
  methods: { useAsset },
  props: {
    errorCode: Number,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.reject-link {
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.24px;
  color: $pj-color-green !important;
  text-decoration: none;
}

#other-offer-card {
  padding: 5%;
  background-color: $pj-color-green-hover;
  border-radius: 5%;
}
</style>
